export default "__VITE_ASSET__QSWpNA1H__"